import { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { activeViewFromPathname, viewLabel } from "../auth/viewAccess";
import { useAuth } from "../state/AuthProvider";
import { useOperations } from "../state/OperationsProvider";
import { AccountMenu } from "./AccountMenu";
import { useAccountMenuModel } from "./useAccountMenuModel";

export function SidebarAccountControl() {
  const { user } = useAuth();
  const { announce } = useOperations();
  const location = useLocation();
  const model = useAccountMenuModel();
  const triggerRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);

  if (!user || !model) return null;

  const activeView = activeViewFromPathname(location.pathname);

  return (
    <div className="sidebar-account">
      <div className="sidebar-account__identity">
        <span className="avatar" aria-hidden="true">
          {model.userInitials}
        </span>
        <div className="sidebar-account__text">
          <strong>{model.userName}</strong>
          <small>{viewLabel(activeView)}</small>
        </div>
      </div>
      <button
        ref={triggerRef}
        type="button"
        className="sidebar-account__trigger"
        aria-label="Open account menu"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <span aria-hidden="true">⋯</span>
      </button>
      {open ? (
        <AccountMenu
          model={model}
          anchorRef={triggerRef}
          onClose={() => {
            setOpen(false);
            announce("Account menu closed");
          }}
        />
      ) : null}
    </div>
  );
}
